import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "item-val"
};
const _hoisted_2 = {
  class: "item-val"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": true,
    title: "用户角色",
    width: "750px",
    "model-value": $props.visible,
    "show-close": false,
    onClose: $setup.close,
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.hanldeSubmit
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("提 交", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "dialog-row"
    }, {
      default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "item-label"
      }, "用户：", -1)), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.userInfo.empName), 1)]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "dialog-row role-div"
    }, {
      default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "item-label"
      }, "角色：", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
        class: "body-scroll"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tree, {
          ref: "roleTreeRef",
          "show-checkbox": "",
          data: _ctx.roleTrees,
          "node-key": "roleId",
          "highlight-current": true,
          props: $setup.roleTreeProps
        }, null, 8, ["data", "props"])]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}